//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    visible: {
      type: Number,
      default:0,
      required: true,
    },
    color: {
      required: true,
    },
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
  }),
  watch:{
      visible: function() {
          this.snackbar = true
      }
  }
};
